import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const api = {
  // Subscribers
  createSubscriber: async (data) => {
    const response = await axios.post(`${API}/subscribers`, data);
    return response.data;
  },

  getSubscriber: async (email) => {
    const response = await axios.get(`${API}/subscribers/${email}`);
    return response.data;
  },

  // A/B Testing
  getABVariant: async (offerPage, userId) => {
    const response = await axios.get(`${API}/ab-variant/${offerPage}/${userId}`);
    return response.data;
  },

  // Cart
  addToCart: async (data) => {
    const response = await axios.post(`${API}/cart/add`, data);
    return response.data;
  },

  getCart: async (userId) => {
    const response = await axios.get(`${API}/cart/${userId}`);
    return response.data;
  },

  clearCart: async (userId) => {
    const response = await axios.delete(`${API}/cart/clear/${userId}`);
    return response.data;
  },

  // Checkout
  createCheckoutSession: async (data) => {
    const response = await axios.post(`${API}/checkout/create-session`, data);
    return response.data;
  },

  resumeCheckout: async (userId) => {
    const response = await axios.get(`${API}/cart/resume-checkout/${userId}`);
    return response.data;
  },

  saveCheckoutSession: async (data) => {
    const response = await axios.post(`${API}/cart/save-checkout-session`, data);
    return response.data;
  },

  // Email Sequences
  enrollInSequence: async (data) => {
    const response = await axios.post(`${API}/email-sequences/enroll`, data);
    return response.data;
  },

  stopSequence: async (userId, sequenceType) => {
    const response = await axios.post(`${API}/email-sequences/stop/${userId}/${sequenceType}`);
    return response.data;
  },

  // Email Templates (Admin)
  getEmailTemplates: async (sequenceType) => {
    const response = await axios.get(`${API}/email-templates/${sequenceType}`);
    return response.data;
  },

  getEmailTemplate: async (sequenceType, emailNumber) => {
    const response = await axios.get(`${API}/email-templates/${sequenceType}/${emailNumber}`);
    return response.data;
  },

  createEmailTemplate: async (data) => {
    const response = await axios.post(`${API}/email-templates`, data);
    return response.data;
  },

  updateEmailTemplate: async (sequenceType, emailNumber, data) => {
    const response = await axios.put(`${API}/email-templates/${sequenceType}/${emailNumber}`, data);
    return response.data;
  },

  initializeEmailTemplates: async () => {
    const response = await axios.post(`${API}/email-templates/initialize`);
    return response.data;
  },

  // Purchases
  createPurchase: async (data) => {
    const response = await axios.post(`${API}/purchases`, data);
    return response.data;
  },

  getPurchases: async () => {
    const response = await axios.get(`${API}/purchases`);
    return response.data;
  },

  // Post-Purchase Emails (Admin)
  getPostPurchaseEmails: async () => {
    const response = await axios.get(`${API}/post-purchase-emails`);
    return response.data;
  },

  getPostPurchaseEmail: async (emailId) => {
    const response = await axios.get(`${API}/post-purchase-emails/${emailId}`);
    return response.data;
  },

  updatePostPurchaseEmail: async (emailId, data) => {
    const response = await axios.put(`${API}/post-purchase-emails/${emailId}`, data);
    return response.data;
  },
};

export default api;